// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/picidae-theme-haier/pages/style/buttons.less
// module id = 652
// module chunks = 26